import React, { useState } from "react";
import ExerciseFilterOptions from "../ExerciseFilterOptions";

interface Props {
  exerciseFilterModal: Function;
  exercisesLookupDetails: any;
  setIsFilterSelected: Function;
}

const ExerciseFilterModal: React.FC<Props> = ({
  exerciseFilterModal,
  exercisesLookupDetails,
  setIsFilterSelected,
}) => {
  const [filteredExercises, setFilteredExercises] = useState<any>();

  const handleFilteredExercises = (filteredExercise: any) => {
    setFilteredExercises(filteredExercise);
  };

  const closeModal = () => {
    exerciseFilterModal(false);
  };

  const assignTempFilterState = async (data: boolean) => {
    setIsFilterSelected(data);
  };

  return (
    <ExerciseFilterOptions
      exercisesLookupDetails={exercisesLookupDetails}
      filteredExercisesList={handleFilteredExercises}
      handleClose={closeModal}
      setIsFilterSelected={assignTempFilterState}
    />
  );
};

export default ExerciseFilterModal;
